
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"width":"20","height":"20","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M17.918 9.584H2.75a.75.75 0 100 1.5h15.168a.75.75 0 100-1.5z","fill":"#000","fill-rule":"nonzero"}})])
      }
    
      }
    


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/line.svg
// module id = null
// module chunks = 